import React, { FC, useEffect, useState } from 'react';
import AddStripePaymentMethodModal from 'app/modules/settings/modules/billing/components/AddStripePaymentMethodModal';
import {
  registerOpener,
  UpgradeOutcome,
} from 'api/client/paymentMethodUpgradeBroker';

/**
 * Mount once near the root of the authenticated React tree (see
 * `PrivateAppProviders.tsx`). Bridges the non-React 409 interceptor in
 * `middleware.utils.ts` to the Stripe attach modal: when the interceptor
 * calls `requestUpgrade()`, this provider opens the modal and resolves the
 * broker's promise with the outcome.
 */
const PaymentMethodUpgradeProvider: FC = () => {
  const [pendingResolve, setPendingResolve] = useState<
    ((o: UpgradeOutcome) => void) | null
  >(null);

  useEffect(() => {
    let activeResolve: ((o: UpgradeOutcome) => void) | null = null;
    registerOpener(
      () =>
        new Promise<UpgradeOutcome>((resolve) => {
          activeResolve = resolve;
          setPendingResolve(() => resolve);
        }),
    );
    return () => {
      activeResolve?.('cancelled');
      registerOpener(null);
    };
  }, []);

  const handleSuccess = () => {
    pendingResolve?.('success');
    setPendingResolve(null);
  };

  const handleClose = () => {
    pendingResolve?.('cancelled');
    setPendingResolve(null);
  };

  return (
    <AddStripePaymentMethodModal
      isOpen={pendingResolve !== null}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
};

export default PaymentMethodUpgradeProvider;
